import { useState } from 'react';
import { Mail } from 'lucide-react';
import FillerModal from '@/components/Fillermodal'; // ✅ import filler modal
import eduardo from '@assets/images/About/Magdaluyo.png';
import raymart from '@assets/images/About/Bonete.png';
import denisse from '@assets/images/About/Pavia.png';
import jamilla from '@assets/images/About/Lumague.png';
import christianne from '@assets/images/About/Calma.png';
import arwin from '@assets/images/About/Luangco.png';
import willmina from '@assets/images/About/Macalino.png';
import mitch from '@assets/images/About/Oyales.png';

export default function AboutTeam() {
  const [isFillerOpen, setIsFillerOpen] = useState(false); // ✅ modal state
  return (
    <>
      <section
        data-aos="fade-up"
        className="mx-auto max-w-6xl bg-white px-4 py-12 pl-6 sm:px-6 sm:py-16 sm:pl-10 md:px-12 md:pl-44 2xl:max-w-[1500px] 2xl:px-60 2xl:pl-80"
      >
        {/* === Header === */}
        <div className="text-center">
          <h2 className="text-2xl font-extrabold tracking-tighter text-[#0B0B0B] sm:text-4xl md:text-4xl">
            The Team Behind AeroComp
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm font-medium tracking-tighter text-black sm:text-base">
            An interdisciplinary group of engineers, researchers, and innovators
            dedicated to advancing sustainable materials and energy
            technologies.
          </p>
        </div>

        {/* === Main Grid === */}
        <div className="mt-10 grid grid-cols-1 gap-6 lg:mt-12 lg:grid-cols-[1.6fr_2fr] lg:gap-8">
          {/* === LEFT SIDE === */}
          <div data-aos="fade-right" className="flex flex-col gap-6">
            {/* --- CEO CARD (WIDER) --- */}
            <div className="flex flex-col items-center justify-start rounded-xl bg-[#0B0B0B] p-6 text-white shadow-lg md:p-8">
              <img
                src={eduardo}
                alt="Eduardo Magdaluyo Jr."
                className="mx-auto h-60 w-auto rounded-lg object-contain md:h-[400px]"
              />
              <div className="mt-4 text-center md:mt-6">
                <h3 className="text-base font-bold md:text-lg">
                  Eduardo <span className="text-[#FFBD59]">Magdaluyo Jr.</span>
                </h3>
                <p className="text-xs text-gray-300 md:text-sm">
                  Chief Executive Officer
                </p>
              </div>
              <div className="mt-3 space-y-2 text-center text-[11px] leading-relaxed text-gray-400 md:mt-4 md:text-xs">
                <p className="text-sm md:text-sm">
                  Expertise: materials synthesis, product design and fabrication
                  of engineering materials for energy
                </p>
                <p className="text-sm md:text-sm">
                  Associate Professor, UPD Mining, Metallurgical and Materials
                  Eng’g
                  <br />
                  M.S. Materials Science and Eng’, UP Diliman
                  <br />
                  B.Sc. Materials Eng’g, UP Diliman
                </p>
              </div>
            </div>

            {/* --- Two Cards Below CEO --- */}
            <div
              data-aos="fade-right"
              className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6"
            >
              <MemberCard
                img={arwin}
                name="Arwin"
                lastname="Luangco"
                position="Project Technical Assistant IV"
                degree1="B.Sc. Materials Eng’g (UP Diliman)"
              />
              <MemberCard
                img={willmina}
                name="Willmina Grace"
                lastname="Macalino"
                position="Project Technical Assistant IV"
                degree1="B.Sc. Materials Eng’g (UP Diliman)"
              />
            </div>
          </div>

          {/* === RIGHT SIDE === */}
          <div
            data-aos="fade-left"
            className="flex flex-col justify-between gap-4 lg:gap-6"
          >
            {/* --- Top Row --- */}
            <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:w-10/12 lg:gap-6">
              <MemberCard
                img={raymart}
                name="Raymart"
                lastname="Bonete"
                position="Chief Technology Officer"
                degree1="M.S. Energy Engineering (UP Diliman)"
                degree2="B.Sc. Mechanical Eng’g (BatStateU)"
              />
              <MemberCard
                img={denisse}
                name="Denisse"
                lastname="Pavia"
                position="Chief Operating Officer"
                degree1="M.S. Environmental Eng’g (UP Diliman)"
                degree2="B.Sc. Mechanical Eng’g (UP Min)"
              />
            </div>

            {/* --- Middle Row --- */}
            <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:w-10/12 lg:gap-6">
              <MemberCard
                img={jamilla}
                name="Jamilla Kim"
                lastname="Lumague"
                position="Project Technical Assistant VI"
                degree1="B.Sc. Materials Eng’g (UP Diliman)"
              />
              <MemberCard
                img={christianne}
                name="Christianne"
                lastname="Calma"
                position="Project Technical Assistant VI"
                degree1="B.Sc. Materials Eng’g (UP Diliman)"
              />
            </div>

            {/* --- Bottom Row --- */}
            <div className="grid w-full grid-cols-1 items-stretch gap-4 sm:grid-cols-2 lg:w-10/12 lg:gap-6">
              <MemberCard
                img={mitch}
                name="Mitch-Irene Kate G."
                lastname="Oyales"
                position="Project Staff"
                degree1="Ph.D. Materials Science & Eng’g (UP Diliman)"
              />

              {/* Contact Us Card */}
              <div className="flex h-full w-full flex-col items-center justify-center rounded-xl bg-white p-4 text-center sm:p-6">
                <p className="max-w-xs text-left text-sm font-medium leading-snug text-[#0B0B0B] sm:text-base md:text-sm">
                  <span className="font-bold">
                    Engineering is not only about solving problems
                  </span>{' '}
                  — it’s about shaping the future.
                </p>
                <button
                  onClick={() => window.open('/appointmentsystem', '_blank')}
                  className="mt-4 flex w-full items-center justify-center gap-2 rounded-md bg-[#FFBD59] px-5 py-2 text-center text-xs font-semibold text-black shadow-md transition hover:bg-[#e6a949] hover:shadow-lg sm:px-6 sm:py-3"
                >
                  <Mail size={16} />
                  Contact us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* === FILLER MODAL === */}
      <FillerModal
        isOpen={isFillerOpen}
        onClose={() => setIsFillerOpen(false)}
        title="Get in Touch with AeroComp"
        message="Our direct APPOINTMENT SYSTEM is currently under development. You can reach us via email at"
        email="aerocompproject@gmail.com"
        subject="Inquiry from AeroComp Website"
        body="Hi AeroComp Team,’d like to inquire about your research and projects."
      />
    </>
  );
}

/* === MemberCard Component === */
function MemberCard({
  img,
  name,
  lastname,
  position,
  degree1,
  degree2,
}: {
  img: string;
  name: string;
  lastname: string;
  position: string;
  degree1: string;
  degree2?: string;
}) {
  return (
    <div className="flex w-full flex-col items-center justify-between rounded-xl bg-[#0B0B0B] p-4 text-center text-white shadow-md sm:min-h-[320px] md:h-[340px]">
      <div className="flex flex-col items-center">
        <img
          src={img}
          alt={`${name} ${lastname}`}
          className="h-32 w-32 rounded-md object-cover sm:h-36 sm:w-36 md:h-44 md:w-44"
        />
        <h4 className="mt-3 text-sm font-semibold leading-tight md:text-base">
          {name} <span className="text-[#FFBD59]">{lastname}</span>
        </h4>
        <p className="text-[11px] text-gray-400 sm:text-xs">{position}</p>
      </div>
      <div className="mt-2">
        <p className="text-[11px] leading-snug text-gray-400 sm:text-xs">
          {degree1}
        </p>
        {degree2 ? (
          <p className="text-[11px] leading-snug text-gray-400 sm:text-xs">
            {degree2}
          </p>
        ) : null}
      </div>
    </div>
  );
}
